module.exports = __webpack_public_path__ + "img/siprizlotto.27a21672.png";